/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */

import axios from '@/axios.js'
import store from "@/store/store.js";

export default {
  fetchCoach({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("trainee-coach/find", query).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("trainee coach not found", err)
        reject(err)
      })
    })
  },
  saveCoachingExp ({ commit }, ceObj) {
    return new Promise((resolve, reject) => {
      store.dispatch("coaching-experience/create", ceObj).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("could not save coaching experience", err)
        reject(err)
      })
    })
  },
  fetchTrainees({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("trainee-coach/find", query)
        .then(res => {
          commit("SET_ALL_TRAINEES", res.data)
          resolve(res)
        })
        .catch(err => {
          console.log("could not found trainees", err);
          reject(err)
        })
    });
  },
  setSidebarId({commit}, id) {
    return new Promise((resolve, reject) => {
      commit("SET_SIDEBAR_ID", id)
      resolve(id)
    })
  },
  fetchCoachingExperience({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("coaching-experience/find", query)
        .then(res => {
          // commit("SET_ALL_TRAINEES", res.data)
          resolve(res)
        })
        .catch(err => {
          console.log("could not find coaching experience", err);
          reject(err)
        })
    });
  }
}
